export default function saveFilePDF(_a) {
  var url = _a.url,
    headers = _a.headers,
    body = _a.body,
    method = _a.method,
    fileName = _a.fileName,
    callBack = _a.callBack;
  fetch(url, {
    body: body,
    method: method,
    headers: headers
  }).then(function (response) {
    return response.blob();
  }).then(function (response) {
    callBack === null || callBack === void 0 ? void 0 : callBack();
    var blob = new Blob([response], {
      type: "application/pdf"
    });
    var downloadUrl = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
  }).catch(function () {
    callBack === null || callBack === void 0 ? void 0 : callBack();
  });
}